<template>
  <v-app id="ai-call-results" class="ai-call-results">
    <!--begin::Dashboard-->
    <div class="card card-custom card-stretch h-auto px-5 py-5">
      <!--begin::Header-->
      <div class="card-header border-0 py-5 align-items-center">
        <h3 class="card-title align-items-start flex-column m-0 py-3">
          <span class="card-label font-weight-bolder text-dark"
            >AI Agent Call Results</span
          >
        </h3>
        <button
          class="btn btn-light font-weight-bolder text-dark-75 position-relative"
          style="z-index: 10 !important"
          v-b-toggle.filter-box
        >
          <v-icon>mdi-tune</v-icon> Filter
        </button>
      </div>
      <!--end::Header-->
      <v-row class="mb-6 px-2">
        <!-- Total Lama Calls Card -->

        <template>
          <v-col cols="12" sm="12" md="6" lg="3" class="pa-2">
            <v-card
              class="rounded-xl elevation-8 transition-swing h-100"
              style="border-top: 6px solid #1976d2; overflow: hidden"
            >
              <v-card-title
                class="blue--text d-flex justify-space-between align-center pa-4"
                style="flex-wrap: nowrap; min-height: 80px"
              >
                <div
                  class="d-flex align-center flex-shrink-1"
                  style="min-width: 0"
                >
                  <v-icon
                    left
                    color="blue darken-2"
                    size="32"
                    class="mr-3 flex-shrink-0"
                  >
                    mdi-alarm-light
                  </v-icon>
                  <span
                    class="font-weight-bold text-h6"
                    style="word-break: break-word; line-height: 1.2"
                  >
                    # of Calls to Update Salary and Availability
                  </span>
                </div>
                <div
                  class="d-flex align-center text-h4 font-weight-bold blue--text text--darken-1 flex-shrink-0 ml-4"
                >
                  {{
                    aiStatistics?.lama_calls?.scheduled +
                    aiStatistics?.lama_calls?.initiated +
                    aiStatistics?.lama_calls?.answered +
                    aiStatistics?.lama_calls?.no_answer
                  }}
                </div>
              </v-card-title>
              <v-divider class="m-0"></v-divider>
              <v-card-text class="px-1 py-1">
                <v-row dense>
                  <v-col cols="12" sm="6" class="px-2 py-2">
                    <v-tooltip bottom content-class="scheduled-lama-tooltip">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          class="d-flex flex-column align-start blue--text pa-3 rounded-lg text-center"
                          style="
                            background-color: rgba(25, 118, 210, 0.08);
                            cursor: pointer;
                          "
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="blue darken-2" size="24"
                            >mdi-alarm</v-icon
                          >
                          <div
                            class="d-flex justify-content-between align-center w-100"
                          >
                            <span class="font-weight-medium body-2"
                              >Scheduled</span
                            >
                            <div class="text-h5 font-weight-bold">
                              {{ aiStatistics?.lama_calls?.scheduled }}
                            </div>
                          </div>
                        </div>
                      </template>
                      <span
                        >Number of calls scheduled with talents but not yet sent
                        to Velents (calls are sent between 9:00 AM and 7:00
                        PM)</span
                      >
                    </v-tooltip>
                  </v-col>
                  <v-col cols="12" sm="6" class="px-2 py-2">
                    <v-tooltip bottom content-class="initiated-tooltip">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          class="d-flex flex-column align-start green--text pa-3 rounded-lg text-center"
                          style="
                            background-color: rgba(76, 175, 80, 0.08);
                            cursor: pointer;
                          "
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="green darken-2" size="24"
                            >mdi-phone-outgoing</v-icon
                          >
                          <div
                            class="d-flex justify-content-between align-center w-100"
                          >
                            <span class="font-weight-medium body-2"
                              >Initiated</span
                            >
                            <div class="text-h5 font-weight-bold">
                              {{ aiStatistics?.lama_calls?.initiated }}
                            </div>
                          </div>
                        </div>
                      </template>
                      <span
                        >Number of calls Pending responses from Velents</span
                      >
                    </v-tooltip>
                  </v-col>
                  <v-col cols="12" sm="6" class="px-2 py-2">
                    <div
                      class="d-flex flex-column align-start blue--text pa-3 rounded-lg text-center"
                      style="background-color: rgba(25, 118, 210, 0.08)"
                    >
                      <v-icon color="blue darken-2" size="24"
                        >mdi-phone-in-talk</v-icon
                      >
                      <div
                        class="d-flex justify-content-between align-center w-100"
                      >
                        <span class="font-weight-medium body-2">Answered</span>
                        <div class="text-h5 font-weight-bold">
                          {{ aiStatistics?.lama_calls?.answered }}
                        </div>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" class="px-2 py-2">
                    <div
                      class="d-flex flex-column align-start red--text pa-3 rounded-lg text-center"
                      style="background-color: rgba(244, 67, 54, 0.08)"
                    >
                      <v-icon color="red darken-2" size="24"
                        >mdi-phone-off</v-icon
                      >
                      <div
                        class="d-flex justify-content-between align-center w-100"
                      >
                        <span class="font-weight-medium body-2"
                          >Unreachable</span
                        >
                        <div class="text-h5 font-weight-bold">
                          {{ aiStatistics?.lama_calls?.no_answer }}
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </template>

        <!-- Total Ghada Contacted Card -->
        <template>
          <v-col cols="12" sm="12" md="6" lg="3" class="pa-2 align-stretch">
            <v-card
              class="rounded-xl elevation-8 transition-swing h-100"
              style="border-top: 6px solid #ffe57f; overflow: hidden"
            >
              <v-card-title
                class="amber--text d-flex justify-space-between align-center pa-4"
                style="flex-wrap: nowrap; min-height: 80px"
              >
                <div
                  class="d-flex align-center flex-shrink-1"
                  style="min-width: 0"
                >
                  <v-icon left color="amber darken-2" size="32" class="mr-3"
                    >mdi-alarm-light</v-icon
                  >
                  <span
                    class="font-weight-bold text-h6"
                    style="word-break: break-word; line-height: 1.2"
                  >
                    # of Calls to Select Slots
                  </span>
                </div>
                <div
                  class="d-flex align-center text-h4 font-weight-bold amber--text text--darken-1 flex-shrink-0 ml-4"
                >
                  {{
                    aiStatistics?.ghada_calls?.scheduled +
                    aiStatistics?.ghada_calls?.initiated +
                    aiStatistics?.ghada_calls?.answered +
                    aiStatistics?.ghada_calls?.no_answer
                  }}
                </div>
              </v-card-title>
              <v-divider class="m-0"></v-divider>
              <v-card-text class="px-1 py-1">
                <v-row dense>
                  <v-col cols="12" sm="6" class="px-2 py-2">
                    <v-tooltip bottom content-class="scheduled-ghada-tooltip">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          class="d-flex flex-column align-start pa-3 rounded-lg text-center"
                          style="background-color: #ffe57f; cursor: pointer"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="black" size="24">mdi-alarm</v-icon>
                          <div
                            class="d-flex justify-content-between align-center w-100"
                          >
                            <span class="font-weight-medium body-2"
                              >Scheduled</span
                            >
                            <div class="text-h5 font-weight-bold">
                              {{ aiStatistics?.ghada_calls?.scheduled }}
                            </div>
                          </div>
                        </div>
                      </template>
                      <span
                        >Number of calls scheduled with talents but not yet sent
                        to Velents (calls are sent between 9:00 AM and 7:00
                        PM)</span
                      >
                    </v-tooltip>
                  </v-col>
                  <v-col cols="12" sm="6" class="px-2 py-2">
                    <v-tooltip bottom content-class="initiated-tooltip">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          class="d-flex flex-column align-start green--text pa-3 rounded-lg text-center"
                          style="
                            background-color: rgba(76, 175, 80, 0.08);
                            cursor: pointer;
                          "
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="green darken-2" size="24"
                            >mdi-phone-outgoing</v-icon
                          >
                          <div
                            class="d-flex justify-content-between align-center w-100"
                          >
                            <span class="font-weight-medium body-2"
                              >Initiated</span
                            >
                            <div class="text-h5 font-weight-bold">
                              {{ aiStatistics?.ghada_calls?.initiated }}
                            </div>
                          </div>
                        </div>
                      </template>
                      <span
                        >Number of calls Pending responses from Velents</span
                      >
                    </v-tooltip>
                  </v-col>
                  <v-col cols="12" sm="6" class="px-2 py-2">
                    <div
                      class="d-flex flex-column align-start pa-3 rounded-lg text-center"
                      style="background-color: #ffe57f"
                    >
                      <v-icon color="black" size="24">mdi-phone-in-talk</v-icon>
                      <div
                        class="d-flex justify-content-between align-center w-100"
                      >
                        <span class="font-weight-medium body-2">Answered</span>
                        <div class="text-h5 font-weight-bold">
                          {{ aiStatistics?.ghada_calls?.answered }}
                        </div>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" class="px-2 py-2">
                    <div
                      class="d-flex flex-column align-start red--text pa-3 rounded-lg text-center"
                      style="background-color: rgba(244, 67, 54, 0.08)"
                    >
                      <v-icon color="red darken-2" size="24"
                        >mdi-phone-off</v-icon
                      >
                      <div
                        class="d-flex justify-content-between align-center w-100"
                      >
                        <span class="font-weight-medium body-2"
                          >Unreachable</span
                        >
                        <div class="text-h5 font-weight-bold">
                          {{ aiStatistics?.ghada_calls?.no_answer }}
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </template>

        <!-- Total Answered Calls (Styled as Screenshot) -->
        <v-col cols="12" sm="6" md="6" lg="3" class="pa-2">
          <v-card
            hover
            class="rounded-xl elevation-8 transition-swing h-100"
            style="
              border-top: 6px solid #ffe57f;
              overflow: hidden;
              cursor: auto;
            "
          >
            <v-card-text class="py-6 h-100">
              <div class="d-flex flex-column h-100">
                <!-- Header -->
                <div class="d-flex align-center justify-space-between mb-4">
                  <div class="d-flex align-center">
                    <v-icon color="warning" size="32" class="mr-2"
                      >mdi-bell</v-icon
                    >
                    <span
                      class="font-weight-bold text-h6"
                      style="color: #ffc107"
                    >
                      Total Answered Calls
                    </span>
                  </div>
                  <span class="font-weight-bold text-h4" style="color: #ffc107">
                    {{ aiStatistics?.answered_calls.total }}
                  </span>
                </div>
                <div class="d-flex flex-column justify-space-center mt-4">
                  <!-- Answered and Message Delivered -->
                  <div
                    class="d-flex align-center mb-4 cursor-pointer"
                    @click="toggleSection('delivered')"
                  >
                    <v-icon color="#2196f3" size="24" class="mr-1">
                      mdi-checkbox-marked
                    </v-icon>
                    <span
                      class="font-weight-bold flex-grow-1"
                      style="color: #2196f3"
                    >
                      Answered and Message Delivered
                    </span>
                    <span class="font-weight-bold mr-2" style="color: #2196f3">
                      {{
                        aiStatistics?.answered_calls?.achieved.ghada +
                        aiStatistics?.answered_calls?.achieved.lama
                      }}
                    </span>
                    <v-icon
                      color="#2196f3"
                      size="20"
                      :class="{ 'rotate-180': expandedSection === 'delivered' }"
                      style="transition: transform 0.3s ease"
                    >
                      mdi-chevron-down
                    </v-icon>
                  </div>

                  <v-expand-transition>
                    <div v-show="expandedSection === 'delivered'" class="mb-4">
                      <div class="d-block mt-3">
                        <div
                          class="d-flex justify-space-between align-center mb-2 pa-2 rounded"
                          style="background-color: rgba(33, 150, 243, 0.1)"
                        >
                          <span
                            class="text-caption font-weight-medium"
                            style="color: #2196f3"
                          >
                            # of Calls to Update Salary and Availability
                          </span>
                          <span class="font-weight-bold" style="color: #2196f3">
                            {{ aiStatistics?.answered_calls?.achieved.lama }}
                          </span>
                        </div>
                        <div
                          class="d-flex justify-space-between align-center pa-2 rounded"
                          style="background-color: rgba(33, 150, 243, 0.1)"
                        >
                          <span
                            class="text-caption font-weight-medium"
                            style="color: #2196f3"
                          >
                            # of Calls to Select Slots
                          </span>
                          <span class="font-weight-bold" style="color: #2196f3">
                            {{ aiStatistics?.answered_calls?.achieved.ghada }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </v-expand-transition>

                  <!--  Answered and Message not Delivered -->
                  <div
                    class="d-flex align-center mb-1 cursor-pointer"
                    @click="toggleSection('dropped')"
                  >
                    <v-icon color="error" size="24" class="mr-1">
                      mdi-close-circle-outline
                    </v-icon>
                    <span class="font-weight-bold flex-grow-1 error--text">
                      Answered and Message not Delivered
                    </span>
                    <span class="font-weight-bold mr-2 error--text">
                      {{
                        aiStatistics?.answered_calls?.not_achieved.ghada +
                        aiStatistics?.answered_calls?.not_achieved.lama
                      }}
                    </span>
                    <v-icon
                      color="error"
                      size="20"
                      :class="{ 'rotate-180': expandedSection === 'dropped' }"
                      style="transition: transform 0.3s ease"
                    >
                      mdi-chevron-down
                    </v-icon>
                  </div>

                  <v-expand-transition>
                    <div v-show="expandedSection === 'dropped'">
                      <div class="d-block mt-3">
                        <div
                          class="d-flex justify-space-between align-center mb-2 pa-2 rounded"
                          style="background-color: rgba(244, 67, 54, 0.1)"
                        >
                          <span
                            class="text-caption font-weight-medium error--text"
                          >
                            # of Calls to Update Salary and Availability
                          </span>
                          <span class="font-weight-bold error--text">
                            {{
                              aiStatistics?.answered_calls?.not_achieved.lama
                            }}
                          </span>
                        </div>
                        <div
                          class="d-flex justify-space-between align-center pa-2 rounded"
                          style="background-color: rgba(244, 67, 54, 0.1)"
                        >
                          <span
                            class="text-caption font-weight-medium error--text"
                          >
                            # of Calls to Select Slots
                          </span>
                          <span class="font-weight-bold error--text">
                            {{
                              aiStatistics?.answered_calls?.not_achieved.ghada
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </v-expand-transition>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="3" class="pa-2">
          <v-card
            hover
            class="rounded-xl elevation-8 transition-swing h-100"
            style="
              border-top: 6px solid #7b1fa2;
              overflow: hidden;
              cursor: auto;
            "
          >
            <v-card-text class="py-6">
              <div class="d-flex flex-column">
                <!-- Total Calls with Issues -->
                <v-tooltip bottom content-class="issues-tooltip">
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      class="d-flex align-center justify-space-between mb-8"
                      style="cursor: pointer"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <div class="d-flex align-center">
                        <v-icon color="error" size="32" class="mr-2"
                          >mdi-bell-off</v-icon
                        >
                        <span class="font-weight-bold text-h6 error--text"
                          >Total Calls with Issues</span
                        >
                      </div>
                      <span class="font-weight-bold text-h4 error--text">{{
                        aiStatistics?.total_calls_with_issues
                      }}</span>
                    </div>
                  </template>
                  <span
                    >Number of calls with no response from Velents for over 2
                    hours</span
                  >
                </v-tooltip>
                <!-- Total Incoming Calls -->
                <div class="d-flex align-center justify-space-between">
                  <div class="d-flex align-center">
                    <v-icon color="purple darken-3" size="32" class="mr-2"
                      >mdi-phone-incoming</v-icon
                    >
                    <span class="font-weight-bold text-h6 purple--text"
                      >Total Incoming Calls</span
                    >
                  </div>
                  <span class="font-weight-bold text-h4 purple--text">{{
                    aiStatistics?.total_calls
                  }}</span>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div class="card card-custom card-stretch h-auto">
      <!--begin::Body-->

      <AICallResultsFilter
        @applyFilter="applyFilter"
        @resetQuery="resetQuery"
      />

      <div class="card-body pt-0 pb-3">
        <div class="tab-content">
          <!--begin::Table-->
          <div
            class="table-responsive mb-0"
            v-if="aiCallResults && aiCallResults.length > 0"
          >
            <table
              class="table table-head-custom table-vertical-center table-head-bg table-borderless"
            >
              <thead>
                <tr class="text-left">
                  <th style="width: 150px">Talent Name</th>
                  <th style="width: 150px">Talent Role</th>
                  <th style="width: 130px">Call Type</th>
                  <th style="width: 100px">Final Status</th>
                  <th style="width: 160px">Phone Number</th>
                  <th style="width: 150px">Squad Name</th>
                  <th style="width: 130px">Output Status</th>
                  <th style="width: 130px">Call Status</th>
                  <th style="width: 130px">Prompt</th>
                  <th style="width: 200px">Scheduled at (UTC)</th>
                  <th style="width: 150px">Email</th>
                  <th style="width: 100px">Language</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="call in aiCallResults"
                  :key="`${call.callable.email}-${call.callable.name}-${call.phone}-${call.initiated_at}`"
                  @click="handleClickCallRecord(call?.call_recording_url)"
                  class="pointer-cursor"
                >
                  <td>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          class="text-dark-75 font-weight-bolder font-size-lg text-clamp-2"
                          v-bind="attrs"
                          v-on="on"
                        >
                          {{ call.callable.name }}
                        </span>
                      </template>
                      <span>{{ call.callable.name }}</span>
                    </v-tooltip>
                  </td>
                  <td>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          class="text-dark-75 font-weight-bolder font-size-lg text-clamp-2 truncate-text"
                          v-bind="attrs"
                          v-on="on"
                        >
                          {{ call.callable.role }}
                        </span>
                      </template>
                      <span>{{ call.callable.role }}</span>
                    </v-tooltip>
                  </td>
                  <td>
                    <span class="text-dark-75 font-weight-bolder font-size-lg">
                      {{
                        call.type === "main"
                          ? "Main"
                          : call.type === "followup"
                          ? "Followup"
                          : "N/A"
                      }}
                    </span>
                  </td>
                  <td>
                    <span class="text-dark-75 font-weight-bolder font-size-lg">
                      {{ getSourceStatusDisplay(call.source_status) }}
                    </span>
                  </td>

                  <td>
                    <span class="text-dark-75 font-weight-bolder font-size-lg">
                      {{ call.phone }}
                    </span>
                  </td>
                  <td class="truncate-text" style="max-width: 150px">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          class="text-dark-75 font-weight-bolder font-size-lg"
                          v-bind="attrs"
                          v-on="on"
                        >
                          {{ call.client_project?.internal_name }}
                        </span>
                      </template>
                      <span>{{ call.client_project?.internal_name }}</span>
                    </v-tooltip>
                  </td>
                  <td>
                    <v-chip
                      :color="getOutputStatusColor(call.output_status)"
                      class="white--text"
                      pill
                    >
                      {{ getOutputStatus(call?.output_status) }}
                    </v-chip>
                  </td>
                  <td>
                    <span
                      class="text-dark-75 font-weight-bolder font-size-lg text-clamp-2"
                      style="min-width: max-content"
                    >
                      {{ getCallStatusDisplay(call.call_status) }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="text-dark-75 font-weight-bolder font-size-lg text-clamp-2"
                    >
                      {{ call.prompt || "N/A" }}
                    </span>
                  </td>
                  <td>
                    <span class="text-dark-75 font-weight-bolder font-size-lg">
                      {{ formatDeadlineDate(call.scheduled_at) }}
                    </span>
                  </td>
                  <td>
                    <span class="text-dark-75 font-weight-bolder font-size-lg">
                      {{ call.callable.email }}
                    </span>
                  </td>
                  <td>
                    <span class="text-dark-75 font-weight-bolder font-size-lg">
                      {{ mapLanguage(call.language) }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- Modal dialog -->
            <v-dialog v-model="dialogVisible" max-width="500">
              <v-card>
                <v-card-title>Call Recording</v-card-title>
                <v-card-text class="d-flex justify-center">
                  <!-- Audio player -->
                  <audio controls :src="audioUrl" v-if="audioUrl"></audio>
                  <v-alert
                    border="right"
                    colored-border
                    type="error"
                    elevation="2"
                    v-else
                  >
                    No recordings were found.
                  </v-alert>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="primary" text @click="handleCloseDialog"
                    >Close</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
          <h5
            class="my-5 text-muted text-center"
            v-if="!aiCallResults || aiCallResults.length === 0"
          >
            No Results Found
          </h5>
          <!--end::Table-->
        </div>
      </div>
      <!--end::Body-->
    </div>
    <!--end::Dashboard-->

    <!-- Call Details Modal -->
    <b-modal id="call-details-modal" title="Call Details">
      <div v-if="selectedCall" class="call-details">
        <!-- Call Status Overview Card -->
        <v-card flat class="mb-4">
          <v-card-title class="subtitle-1 font-weight-bold d-flex align-center">
            <v-icon left color="primary">mdi-phone</v-icon>
            Call Status Overview
          </v-card-title>
          <v-card-text>
            <b-badge
              :variant="getCallStatusColor(selectedCall.callStatus)"
              pill
              class="mr-2"
            >
              {{ selectedCall.callStatus }}
            </b-badge>
            <b-badge
              :variant="getCompletionColor(selectedCall.profileCompletion)"
              pill
              class="mr-2"
            >
              {{ selectedCall.profileCompletion }}% Complete
            </b-badge>
            <b-badge
              :variant="getFollowUpColor(selectedCall.followUpStatus)"
              pill
            >
              {{ selectedCall.followUpStatus }}
            </b-badge>
          </v-card-text>
        </v-card>

        <!-- Call History Timeline -->
        <v-card flat class="mb-4">
          <v-card-title class="subtitle-1 font-weight-bold d-flex align-center">
            <v-icon left color="primary">mdi-history</v-icon>
            Call History
          </v-card-title>
          <v-card-text>
            <v-timeline dense>
              <v-timeline-item
                v-for="attempt in selectedCall.attempts"
                :key="attempt.id"
                :color="getStatusColor(attempt.status)"
                small
              >
                <template v-slot:icon>
                  <v-icon :color="getStatusColor(attempt.status)">
                    {{ getStatusIcon(attempt.status) }}
                  </v-icon>
                </template>
                <div class="d-flex justify-space-between align-center">
                  <div>
                    <span class="font-weight-medium">{{ attempt.status }}</span>
                    <div class="text-caption">{{ attempt.timestamp }}</div>
                  </div>
                </div>
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
        </v-card>

        <!-- Response Details -->
        <v-card flat>
          <v-card-title class="subtitle-1 font-weight-bold d-flex align-center">
            <v-icon left color="primary">mdi-comment-text</v-icon>
            Response Details
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <v-card outlined>
                  <v-card-text>
                    <div class="d-flex align-center mb-2">
                      <v-icon color="primary" class="mr-2"
                        >mdi-message-text</v-icon
                      >
                      <div class="font-weight-medium">Talent Response</div>
                    </div>
                    <div class="text-body-2">{{ selectedCall.responses }}</div>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" md="4">
                <v-card outlined>
                  <v-card-text>
                    <div class="d-flex align-center mb-2">
                      <v-icon
                        :color="selectedCall.voicemail ? 'success' : 'error'"
                        class="mr-2"
                      >
                        {{
                          selectedCall.voicemail
                            ? "mdi-voicemail"
                            : "mdi-voicemail-off"
                        }}
                      </v-icon>
                      <div class="font-weight-medium">Voicemail Status</div>
                    </div>
                    <div class="text-body-2">
                      {{
                        selectedCall.voicemail
                          ? "Voicemail Left"
                          : "No Voicemail"
                      }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" md="4">
                <v-card outlined>
                  <v-card-text>
                    <div class="d-flex align-center mb-2">
                      <v-icon
                        :color="
                          selectedCall.followUpPlanned ? 'success' : 'grey'
                        "
                        class="mr-2"
                      >
                        mdi-calendar-check
                      </v-icon>
                      <div class="font-weight-medium">Follow-up</div>
                    </div>
                    <div class="text-body-2">
                      {{
                        selectedCall.followUpPlanned
                          ? "Follow-up Scheduled"
                          : "No Follow-up Planned"
                      }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
    </b-modal>

    <!-- Pagination Component -->
    <div class="pagination-container">
      <p
        v-if="aiCallResults && aiCallResults.length > 0"
        class="pagination-container__desc"
      >
        {{
          $t("showing_results", {
            length: `${aiCallResultsMeta.from} - ${aiCallResultsMeta.to}`,
            total: aiCallResultsMeta.total,
          })
        }}
      </p>
      <b-pagination
        v-if="aiCallResultsMeta && aiCallResultsMeta.last_page > 1"
        v-model="page"
        :total-rows="aiCallResultsMeta.total"
        :per-page="perPage"
        align="center"
        last-number
        first-number
        @change="handlePageChange"
      ></b-pagination>
    </div>
  </v-app>
</template>

<script>
import AICallResultsFilter from "@/components/ai-call-results/AICallResultsFilter.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AICallResults",
  components: {
    AICallResultsFilter,
  },
  data() {
    return {
      filteredCalls: [],
      selectedCall: null,
      page: 1,
      perPage: 8,
      filters: {},
      audioUrl: null,
      dialogVisible: false,
      expandedSection: null,
    };
  },
  computed: {
    ...mapGetters({
      aiCallResults: "aiCallResults/getAICallResults",
      aiCallResultsMeta: "aiCallResults/getAICallResultsMeta",
      aiStatistics: "aiCallResults/getAIStatistics",
    }),
    aiCallResultsQuery() {
      return {
        page: this.page,
        perPage: this.perPage,
      };
    },
    getOutputStatus() {
      return (status) => {
        switch (status) {
          case "ACHIEVED":
            return "Message Delivered";
          case "NO_ANSWER":
            return "Unreachable";
          case "NOT_ACHIEVED":
            return "Message not Delivered";
          default:
            return "N/A";
        }
      };
    },
    getOutputStatusColor() {
      return (status) => {
        switch (status) {
          case "ACHIEVED":
            return "#4CAF50";
          case "NO_ANSWER":
            return "#f44336";
          case "NOT_ACHIEVED":
            return "#f44336";
          default:
            return "warning";
        }
      };
    },
    getCallStatusDisplay() {
      return (status) => {
        switch (status) {
          case "ai_call_issue":
            return "Issue with the Provider";
          default:
            return status?.toUpperCase();
        }
      };
    },
    mapLanguage() {
      return (language) => {
        switch (language) {
          case "ar":
            return "Arabic";
          case "en":
            return "English";
          default:
            return "English";
        }
      };
    },
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.audioUrl = null;
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Dashboard", route: "/dashboard" },
      { title: "AI Call Results" },
    ]);
    this.fetchAICallResults(this.aiCallResultsQuery);
    this.fetchAIStatistics();
  },
  methods: {
    ...mapActions({
      fetchAICallResults: "aiCallResults/fetchAICallResults",
      fetchAIStatistics: "aiCallResults/fetchAIStatistics",
    }),
    showCallDetails(call) {
      this.selectedCall = call;
      this.$bvModal.show("call-details-modal");
    },
    applyFilter(data) {
      this.filters = { ...data };
      this.page = 1;
      this.fetchAICallResults({ ...data, ...this.aiCallResultsQuery });
      this.fetchAIStatistics();
    },
    resetQuery() {
      this.filters = {};
      this.page = 1;
      this.fetchAICallResults({ page: 1, perPage: 8 });
      this.fetchAIStatistics();
    },
    getStatusColor(status) {
      switch (status) {
        case "Answered":
          return "success";
        case "No Answer":
          return "warning";
        case "Voicemail":
          return "info";
        case "Busy":
          return "error";
        default:
          return "grey";
      }
    },
    getStatusIcon(status) {
      switch (status) {
        case "Answered":
          return "mdi-phone-in-talk";
        case "No Answer":
          return "mdi-phone-missed";
        case "Voicemail":
          return "mdi-voicemail";
        case "Busy":
          return "mdi-phone-off";
        default:
          return "mdi-help-circle";
      }
    },
    getCallStatusColor(callStatus) {
      switch (callStatus) {
        case "Answered":
          return "success";
        case "No Answer":
          return "warning";
        case "Voicemail":
          return "primary";
        case "Busy":
          return "danger";
        default:
          return "secondary";
      }
    },
    getCompletionColor(profileCompletion) {
      return profileCompletion >= 80 ? "success" : "danger";
    },
    getFollowUpColor(followUpStatus) {
      return followUpStatus === "Scheduled" ? "primary" : "secondary";
    },
    formatDeadline(deadline) {
      // Assuming deadline is a string like '3 days', '1 day', etc.
      if (!deadline) return "N/A";
      const [value, unit] = deadline.split(" ");
      return `${value} ${unit}${value > 1 ? "s" : ""}`;
    },
    getSourceStatusDisplay(sourceStatus) {
      return sourceStatus
        .replace(/_/g, " ")
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");
    },
    getProfileCompletionDisplay(profileCompletion) {
      return profileCompletion ? `${profileCompletion}%` : "N/A";
    },
    formatDeadlineDate(date) {
      if (!date) return "N/A";
      const d = new Date(date);
      const day = d.getUTCDate();
      const month = d.getUTCMonth() + 1;
      const year = d.getUTCFullYear();
      let hours = d.getUTCHours();
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // Convert 0 to 12
      const minutes = d.getUTCMinutes().toString().padStart(2, "0");
      const seconds = d.getUTCSeconds().toString().padStart(2, "0");
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${ampm}`;
    },
    getDeadlineCountdownDisplay(deadline) {
      if (!deadline) return "N/A";

      const deadlineDate = new Date(deadline);
      const now = new Date();
      const diffInMs = deadlineDate - now;

      // If deadline has passed
      if (diffInMs <= 0) {
        return "Expired";
      }

      // Calculate time components
      const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
      const diffInMinutes = Math.floor(
        (diffInMs % (1000 * 60 * 60)) / (1000 * 60)
      );

      // Format the display
      if (diffInHours > 0) {
        return `${diffInHours} hour${diffInHours !== 1 ? "s" : ""}  remaining`;
      } else {
        return `${diffInMinutes} minute${
          diffInMinutes !== 1 ? "s" : ""
        } remaining`;
      }
    },
    handlePageChange(page) {
      this.page = page;
      this.fetchAICallResults({ ...this.filters, ...this.aiCallResultsQuery });
    },
    handleClickCallRecord(recordUrl) {
      this.audioUrl = recordUrl;
      this.dialogVisible = true;
    },
    handleCloseDialog() {
      this.audioUrl = null;
      this.dialogVisible = false;
    },
    toggleSection(section) {
      this.expandedSection = this.expandedSection === section ? null : section;
    },
  },
};
</script>

<style>
.table-responsive {
  overflow-x: auto;
}
.break-word {
  word-break: break-word;
  overflow-wrap: break-word;
}
.min-w-180px {
  min-width: 180px;
}
.truncate-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pointer-cursor {
  cursor: pointer;
}

.scheduled-lama-tooltip {
  background-color: #1976d2 !important;
  color: #fff !important;
  font-weight: 500;
}
.scheduled-ghada-tooltip {
  background-color: #ffe57f !important;
  color: #7c5f00 !important;
  font-weight: 500;
}
.initiated-tooltip {
  background-color: #4caf50 !important;
  color: #fff !important;
  font-weight: 500;
}
.issues-tooltip {
  background-color: #f44336 !important;
  color: #fff !important;
  font-weight: 500;
}
.cursor-pointer {
  cursor: pointer;
}

.rotate-180 {
  transform: rotate(180deg);
}
</style>
